/*@flow*/
import useItems from './useItems';
import type { PathT } from '../types';

export default function useRadioItems(path: PathT): any | Array<{text: string, value: any, ...}> {
  return useItems(path);
}

